export const REEL_MUSIC_SKELETON_TRACK_COUNT = 4;
export const REEL_MUSIC_SKELETON_ARTWORK_SIZE_PX = 44;
export const REEL_MUSIC_SKELETON_TITLE_WIDTH_PX = 140;
export const REEL_MUSIC_SKELETON_DETAILS_WIDTH_PX = 96;
export const REEL_MUSIC_SKELETON_LINE_HEIGHT_PX = 12;
